const safety = [
	'Intarder',
	'Retarder',
	'Tachograf',
	'Blokada mostu',
]

const comfort = [
	'CB radio',
	'DVD',
	'Kabina sypialna',
	'Kuchnia',
	'lodówka ',
	'Minibar',
	'Regulowane zawieszenie',
	'Toaleta',
	'Winda',
	'Jedno łóżko',
	'Dwa łóżka',
]

export default [...safety, ...comfort]
export {
    safety,
    comfort,
}